<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-spinner"></div>
    <p class="loading-label">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #ddd;
  border-top-color: #333;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-label {
  margin-top: 15px;
  font-size: 16px;
  color: #333;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>


